// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.promotionMain {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    padding: 77px 16px 110px 16px;
}

.promotionContent {
    width: 100%;
    display: flex;
    flex-direction: column;
    background: #FFF4D9;
    padding: 30px 18px 13px 18px;
    position: relative;
    z-index: 99;
    border-radius: 16px;
    gap: 9px;
}

.promotionTitle {
    font-family: Alegreya Sans;
    font-size: 32px;
    font-weight: 700;
    line-height: 25.6px;
    text-align: center;
    color: rgba(75, 45, 16, 1);
}

.promotionLine {
    display: flex;
    flex-direction: row;
    gap: 24px;
}

.promotionSmallBlock {
    width: 50%;
    background: rgba(255, 232, 174, 1);
    border-radius: 16px;
    padding: 12px 11px 6px 11px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    justify-content: center;
}

.promotionBigBlock {
    width: 100%;
    background: rgba(255, 232, 174, 1);
    border-radius: 16px;
    padding: 12px 11px 6px 11px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    justify-content: center;
}

.promotionCoverBox {
    width: 100%;
    height: 134px;
    border-radius: 12px;
    border: solid 2px rgba(255, 107, 0, 1);
    background: rgba(255, 244, 217, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.promotionCover {
    height: 125px;
    object-fit: cover;
    margin-top: 7px;
}

.promotionSale {
    padding: 5px 7.5px;
    border-radius: 16px;
    background: rgba(255, 107, 0, 1);
    text-align: center;
    color: rgba(255, 244, 217, 1);
    font-size: 20px;
    line-height: 100%;
    font-weight: 700;
    position: absolute;
    margin-left: 90px;
    margin-top: 125px;
}

.promotionSaleBig {
    padding: 5px 7.5px;
    border-radius: 16px;
    background: rgba(255, 107, 0, 1);
    text-align: center;
    color: rgba(255, 244, 217, 1);
    font-size: 20px;
    line-height: 100%;
    font-weight: 700;
    position: absolute;
    right: 30px;
    margin-top: 125px;
}

.promotionItemTitle {
    color: rgba(142, 59, 0, 1);
    text-align: center;
    font-family: Alegreya Sans;
    font-size: 18px;
    font-weight: 500;
    line-height: 18px;
    width: 120px;
}

.promotionItemBigTitle {
    color: rgba(142, 59, 0, 1);
    text-align: center;
    font-family: Alegreya Sans;
    font-size: 18px;
    font-weight: 500;
    line-height: 18px;
    width: 100%;
}

.promotionCostLine {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 6px;
}

.promotionItemCost {
    font-family: Alegreya Sans;
    font-size: 32px;
    font-weight: 700;
    line-height: 22.4px;
    text-align: left;
    color: rgba(142, 59, 0, 1);
}

.promotionItemCostOld {
    font-family: Alegreya Sans;
    font-size: 16px;
    font-weight: 700;
    line-height: 12.8px;
    text-align: left;
    color: rgba(187, 141, 108, 1);
    text-decoration: line-through;
}

ul {
    padding-left: 11px;
    height: 84px;
}

li {
    font-family: Alegreya Sans;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.8px;
    text-align: left;
    color: rgba(142, 59, 0, 1);
}

.promotionItemHr {
    width: 100%;
    border: none;
    border-top: solid 1px rgba(187, 141, 108, 1);
}

.promotionItemTerm {
    font-family: Alegreya Sans;
    font-size: 24px;
    font-weight: 700;
    line-height: 16.8px;
    text-align: left;
    color: rgba(142, 59, 0, 1);
}

.promotionBigUl {
    height: auto;
    padding: 0 0 0 11px;
    width: 100%;
}

.promotionButton {
    border: none;
    background: rgba(250, 159, 94, 1);
    height: 36px;
    border-radius: 8px;
    font-family: Alegreya Sans;
    font-size: 20px;
    font-weight: 700;
    line-height: 16px;
    text-align: center;
    color: rgba(255, 228, 208, 1);
    width: 100%;
}

.promotionButtonSelect {
    background: rgba(255, 107, 0, 1);
}

.promotionBlockSelect {
    outline: solid 4px rgba(255, 184, 0, 1);
}

.link {
    min-width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/Profile/Promotion/Promotion.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,4BAA4B;IAC5B,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,kCAAkC;IAClC,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,kCAAkC;IAClC,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,sCAAsC;IACtC,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,6BAA6B;IAC7B,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,4CAA4C;AAChD;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,iCAAiC;IACjC,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".promotionMain {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    padding: 77px 16px 110px 16px;\n}\n\n.promotionContent {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    background: #FFF4D9;\n    padding: 30px 18px 13px 18px;\n    position: relative;\n    z-index: 99;\n    border-radius: 16px;\n    gap: 9px;\n}\n\n.promotionTitle {\n    font-family: Alegreya Sans;\n    font-size: 32px;\n    font-weight: 700;\n    line-height: 25.6px;\n    text-align: center;\n    color: rgba(75, 45, 16, 1);\n}\n\n.promotionLine {\n    display: flex;\n    flex-direction: row;\n    gap: 24px;\n}\n\n.promotionSmallBlock {\n    width: 50%;\n    background: rgba(255, 232, 174, 1);\n    border-radius: 16px;\n    padding: 12px 11px 6px 11px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    align-items: center;\n    justify-content: center;\n}\n\n.promotionBigBlock {\n    width: 100%;\n    background: rgba(255, 232, 174, 1);\n    border-radius: 16px;\n    padding: 12px 11px 6px 11px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    align-items: center;\n    justify-content: center;\n}\n\n.promotionCoverBox {\n    width: 100%;\n    height: 134px;\n    border-radius: 12px;\n    border: solid 2px rgba(255, 107, 0, 1);\n    background: rgba(255, 244, 217, 1);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n}\n\n.promotionCover {\n    height: 125px;\n    object-fit: cover;\n    margin-top: 7px;\n}\n\n.promotionSale {\n    padding: 5px 7.5px;\n    border-radius: 16px;\n    background: rgba(255, 107, 0, 1);\n    text-align: center;\n    color: rgba(255, 244, 217, 1);\n    font-size: 20px;\n    line-height: 100%;\n    font-weight: 700;\n    position: absolute;\n    margin-left: 90px;\n    margin-top: 125px;\n}\n\n.promotionSaleBig {\n    padding: 5px 7.5px;\n    border-radius: 16px;\n    background: rgba(255, 107, 0, 1);\n    text-align: center;\n    color: rgba(255, 244, 217, 1);\n    font-size: 20px;\n    line-height: 100%;\n    font-weight: 700;\n    position: absolute;\n    right: 30px;\n    margin-top: 125px;\n}\n\n.promotionItemTitle {\n    color: rgba(142, 59, 0, 1);\n    text-align: center;\n    font-family: Alegreya Sans;\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 18px;\n    width: 120px;\n}\n\n.promotionItemBigTitle {\n    color: rgba(142, 59, 0, 1);\n    text-align: center;\n    font-family: Alegreya Sans;\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 18px;\n    width: 100%;\n}\n\n.promotionCostLine {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 6px;\n}\n\n.promotionItemCost {\n    font-family: Alegreya Sans;\n    font-size: 32px;\n    font-weight: 700;\n    line-height: 22.4px;\n    text-align: left;\n    color: rgba(142, 59, 0, 1);\n}\n\n.promotionItemCostOld {\n    font-family: Alegreya Sans;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 12.8px;\n    text-align: left;\n    color: rgba(187, 141, 108, 1);\n    text-decoration: line-through;\n}\n\nul {\n    padding-left: 11px;\n    height: 84px;\n}\n\nli {\n    font-family: Alegreya Sans;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 16.8px;\n    text-align: left;\n    color: rgba(142, 59, 0, 1);\n}\n\n.promotionItemHr {\n    width: 100%;\n    border: none;\n    border-top: solid 1px rgba(187, 141, 108, 1);\n}\n\n.promotionItemTerm {\n    font-family: Alegreya Sans;\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 16.8px;\n    text-align: left;\n    color: rgba(142, 59, 0, 1);\n}\n\n.promotionBigUl {\n    height: auto;\n    padding: 0 0 0 11px;\n    width: 100%;\n}\n\n.promotionButton {\n    border: none;\n    background: rgba(250, 159, 94, 1);\n    height: 36px;\n    border-radius: 8px;\n    font-family: Alegreya Sans;\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 16px;\n    text-align: center;\n    color: rgba(255, 228, 208, 1);\n    width: 100%;\n}\n\n.promotionButtonSelect {\n    background: rgba(255, 107, 0, 1);\n}\n\n.promotionBlockSelect {\n    outline: solid 4px rgba(255, 184, 0, 1);\n}\n\n.link {\n    min-width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
